import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import store from './store'

import home from '@/views/home/home.vue'
import about from '@/views/about/about.vue'
import poll from '@/views/poll/poll.vue'
import changelog from '@/views/changelog/changelog.vue'
import contact from '@/views/contact/contact.vue'
import toolbox from '@/views/toolbox/toolbox.vue'
import alerts from '@/views/alerts/alerts.vue'
import weeks from '@/views/weeks/weeks.vue'
import category from '@/views/category/category.vue'
import compareTeams from '@/views/compare-teams/compare-teams.vue'
import compareRosters from '@/views/compare-rosters/compare-rosters.vue'

const profile = () => import(/* webpackChunkName: "profile" */ "@/views/profile/profile.vue")
const pay = () => import(/* webpackChunkName: "pay" */ "@/views/pay/pay.vue")
const faq = () => import(/* webpackChunkName: "faq" */ "@/views/faq/faq.vue")

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'home',
    component: home,
    meta: { static: true }
  },
  {
    path: '/toolbox',
    name: 'toolbox',
    component: toolbox,
    meta: { requiresAuth: true },
    children: [
      {
        path: '/toolbox/weeks',
        name: 'weeks',
        component: weeks
      },
      {
        path: '/toolbox/category',
        name: 'category',
        component: category
      },
      {
        path: '/toolbox/compare-teams',
        name: 'compare-teams',
        component: compareTeams
      },
      {
        path: '/toolbox/compare-rosters',
        name: 'compare-rosters',
        component: compareRosters
      },
    ],
    beforeEnter: (to: any, from: any, next: any) => {
      if (to.path === '/toolbox') {
        next({replace: true, name: 'weeks'})
      } else {
        next()
      }
    }
  },
  {
    path: '/about',
    name: 'about',
    component: about,
    // meta: { static: true }
  },
  {
    path: '/alerts',
    name: 'alerts',
    component: alerts,
    meta: {requiresAuth: true }
  },
  {
    path: '/poll',
    name: 'poll',
    component: poll,
    // meta: { static: true }
  },
  {
    path: '/contact',
    name: 'contact',
    component: contact,
    // meta: { static: true }
  },
  {
    path: '/changelog',
    name: 'changelog',
    component: changelog,
    // meta: { static: true }
  },
  {
    path: '/faq',
    name: 'faq',
    component: faq,
    meta: { static: true }
  },
  {
    path: '/pay',
    name: 'pay',
    component: pay
  },
  {
    path: "/profile",
    name: "profile",
    component: profile,
    meta: { requiresAuth: true }
  },
  {
    path: '*',
    redirect: { name: 'home' }
  }
]

var router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior: () => ({ x: 0, y: 0 })
})

router.beforeEach(async (to: any, from: any, next: any) => {
  if (to.matched.some((record: RouteConfig) => record.meta.requiresAuth)) {
    await store.dispatch('getUser');
    if (store.getters.currentUser) {
      next();
    } else {
      store.dispatch('login');
    }
  } else {
    next();
  }
})

export default router
